import React, {useEffect, useRef} from 'react';

const EllipseOverlay = ({feedback, webcamRef}) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        if (!canvas || !webcamRef.current || !webcamRef.current.video) return;

        const video = webcamRef.current.video;
        const ctx = canvas.getContext('2d');

        const updateCanvasSize = () => {
            const {width, height} = video.getBoundingClientRect();

            // Set display size
            canvas.style.width = `${width}px`;
            canvas.style.height = `${height}px`;

            // Set actual size
            canvas.width = width;
            canvas.height = height;

            // Clear canvas
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Inside the updateCanvasSize function
            const centerX = width / 2;
            const centerY = height / 2;

            const minDimension = Math.min(width, height);
            const ellipseWidth = minDimension * 0.9;
            const ellipseHeight = ellipseWidth * 1.5; // slightly oval, or use ellipseWidth for perfect circle

            ctx.beginPath();
            ctx.save();
            ctx.translate(centerX, centerY);
            ctx.ellipse(
                0, 0,
                ellipseWidth / 2,
                ellipseHeight / 2,
                0, 0, 2 * Math.PI
            );

            ctx.strokeStyle = 'rgba(255, 255, 0, 0.8)';
            ctx.lineWidth = 3;
            ctx.stroke();
            ctx.restore();
        };

        // Initial draw
        updateCanvasSize();

        // Update when video dimensions change
        const resizeObserver = new ResizeObserver(updateCanvasSize);
        resizeObserver.observe(video);

        return () => {
            resizeObserver.disconnect();
        };
    }, [webcamRef]); // Removed feedback dependency

    return (
        <canvas
            ref={canvasRef}
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none'
            }}
        />
    );
};

export default EllipseOverlay;